<template>
  <div>
    <p class="title is-3 is-spaced">Currencies</p>

    <section class="accordions">
      <article class="accordion" :class="{'is-active': newCurrencyVisible}">
        <div class="accordion-header toggle is-size-5" @click="newCurrencyVisible = !newCurrencyVisible">
          <a>New currency ⯆</a>
        </div>
        <div class="accordion-body">
          <div class="accordion-content has-background-dark has-text-white">
            <div class="field">
              <label class="label">Code</label>
              <div class="control">
                <input class="input oc-input" type="text" v-model="newCurrency.id">
              </div>
            </div>
            <div class="field">
              <label class="label">Symbol</label>
              <div class="control">
                <input class="input oc-input" type="text" v-model="newCurrency.symbol">
              </div>
            </div>
            <div class="field">
              <label class="label">Description</label>
              <div class="control">
                <input class="input" type="text" v-model="newCurrency.description">
              </div>
            </div>
            <div class="field">
              <label class="label">Decimals</label>
              <div class="control">
                <input class="input oc-input" type="number" v-model="newCurrency.decimals">
              </div>
            </div>
            <div class="field">
              <label class="label">Game denomination</label>
              <div class="control">
                <input class="input oc-input" type="number" v-model="newCurrency.gameDenomination">
              </div>
            </div>
            <div class="field">
              <label class="label">Rate to 1 USD</label>
              <div class="control">
                <input class="input oc-input" type="number" v-model="newCurrency.rateTo1Usd">
              </div>
            </div>

            <div class="field">
              <div class="control">
                <button class="button is-success" @click="create()" :disabled="!newCurrency.id || !newCurrency.symbol || !newCurrency.description || !newCurrency.decimals || !newCurrency.gameDenomination">Create currency</button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <table class="table">
      <tr>
        <th>Code</th>
        <th>Symbol</th>
        <th>Description</th>
        <th>Decimals</th>
        <th>Game denomination</th>
        <th>Rate to 1 USD</th>
      </tr>
      <tr v-for="currency in currencies" :key="currency.id">
        <th>{{currency.id}}</th>
        <td>{{currency.symbol}}</td>
        <td>{{currency.description}}</td>
        <td>{{currency.decimals}}</td>
        <td>{{currency.gameDenomination}}</td>
        <td>{{currency.rateTo1Usd}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
  import state from '../../state';
  import currencyService from '../../services/currency.service';

  export default {
    name: 'currencies',
    data() {
      return {
        newCurrencyVisible: false,
        newCurrency: {
          id: null,
          symbol: null,
          description: null,
          decimals: 2,
          gameDenomination: 0.01
        }
      }
    },
    computed: {
      currencies() {
        return state.currencies.get();
      }
    },
    methods: {
      async create() {
        await currencyService.create(this.newCurrency);
        await currencyService.reloadAll();
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/system/currencies.vue